$(document).ready(function(){
    let sticky = $('.rx__announcement-swiper.has-sticky');
    if(sticky.length){
        $('.shopify-section__header-multi').addClass('has-sticky-bar')
    }
    var lastScrollTop = 0;
    $(window).on('scroll', function(e){
        var st = $(this).scrollTop();
        if (st > lastScrollTop){
            $('.shopify-section__header-multi').removeClass('sticky')
            if (($(window).scrollTop()) >= $('.shopify-section__header-multi').offset().top + $('.shopify-section__header-multi').outerHeight()) {
                $('.shopify-section__header-multi').addClass('shopify-section-header-hidden')
            }
        } else {
            $('.shopify-section__header-multi').removeClass('shopify-section-header-hidden').addClass('sticky')
           // upscroll code
        }
        lastScrollTop = st;
    }); 
    $(window).click(function(event) {
        let p = $(event.target).closest('.popover')
        let p2 = $(event.target).closest('.mega-menu')
        let p3 = $(event.target).closest('.nav-dropdown')
        let p4 = $(event.target).closest('#mobile-menu')
        if ($(event.target).attr('data-action') === 'toggle-popover' || p.length) {
            return; 
        }
        if ($(event.target).attr('data-type') === 'menuitem' || p2.length || p3.length || p4.length) {
            return;
        }
        $('[data-action="toggle-popover"]').attr('aria-expanded', 'false')
        $('[data-type="menuitem"]').attr('aria-expanded', 'false')
        $('[data-type="toggle-menu"]').attr('aria-expanded', 'false')
        $('[aria-hidden]').attr('aria-hidden', 'true')
    });

    $('[data-action="toggle-search"]').on('click', function(e){
        e.preventDefault();
        let expanded = $(this).attr('aria-expanded');
        if(expanded && expanded=='true'){
            $('.header__search-bar-wrapper').removeClass('is-visible');
            $('.header-multi').removeClass('header--search-expanded');
            $(this).attr('aria-expanded', 'false')
        }else{
            $('.header__search-bar-wrapper').addClass('is-visible');
            $('.header-multi').addClass('header--search-expanded');
            $(this).attr('aria-expanded', 'true')
        }
    })
    $('[data-action="toggle-popover"],[aria-haspopup]').on('click', function(e){
        e.preventDefault();
        e.stopPropagation();
        let expanded = $(this).attr('aria-expanded');
        let control = $(this).attr('aria-controls');
        
        if(expanded && expanded=='true'){
            $(this).attr('aria-expanded', 'false')
            $(`#${control}`).attr('aria-hidden', 'true')
        }else{
            $('[data-action="toggle-popover"]').attr('aria-expanded', 'false')
            if ($(this).attr('aria-haspopup')) {
                $('[aria-haspopup]:not(.header__mobile-nav-toggle)').attr('aria-expanded', 'false')
                $('[aria-hidden]:not(.mobile-menu)').attr('aria-hidden', 'true')
            }else{
                $('[aria-haspopup]').attr('aria-expanded', 'false')
                $('[aria-hidden]').attr('aria-hidden', 'true')
            }
            $(this).attr('aria-expanded', 'true')
            $(`#${control}`).attr('aria-hidden', 'false')
        }
    })
    
    $('[data-action="close-panel"]').on('click', function(e){
        $(this).parents('.mobile-menu__panel').attr('aria-hidden', 'true')
    })
    $('[data-action="toggle-collapsible"]').on('click', function(e){
        let expanded = $(this).attr('aria-expanded');
        let control = $(`#${$(this).attr('aria-controls')}`);
        if(expanded && expanded === 'true'){
            $(this).attr('aria-expanded', 'true');
            control.slideDown('slow');
        }else{
            $(this).attr('aria-expanded', 'false');
            // let autoHeight = control.css('height', 'auto').height();
            control.slideUp('slow');
        }
    })
})